(() => {
  const memory = window.JuronoidPopupMemory;
  if (!memory) return;
  const hosts = new Map();
  const selector = 'shopify-forms-embed[id^="app-embed-container-"]';
  const isClose = node => node?.getAttribute?.('aria-label') === 'Close modal';
  const suppress = state => {
    state.blocked = true;
    if (state.host.dataset.juronoidSuppressed !== 'true') state.host.dataset.juronoidSuppressed = 'true';
    state.host.inert = true;
    const close = state.root.querySelector('[aria-label="Close modal"]');
    if (close && !state.closedButtons.has(close)) {
      state.closedButtons.add(close);
      close.click();
    }
  };
  const synchronize = state => {
    const app = state.root.querySelector('#app-embed');
    if (!app || app.dataset.layout === 'inline') return;
    if (!state.target) {
      const text = app.textContent || '';
      state.target = memory.welcomeSeen(state.id) || (/10\s*%/.test(text) && /rabatt|willkommen|bestell|discount|off\b/i.test(text));
      if (!state.target) return;
      state.blocked = !memory.canRememberWelcome || memory.welcomeSeen(state.id) || memory.nativeWelcomeDismissed(state.id);
      state.host.dataset.juronoidWelcome = 'true';
      if (state.blocked) memory.rememberWelcome(state.id);
    }
    if (state.blocked) {
      suppress(state);
      return;
    }
    const step = app.dataset.currentStep;
    if (!state.impressed && ['tease', 'form', 'success'].includes(step)) {
      state.impressed = true;
      memory.rememberWelcome(state.id);
      state.host.dataset.juronoidFirstImpression = 'true';
    }
    if (step === 'form' || step === 'success') {
      state.displayed = true;
    } else if (state.displayed && step === 'tease') {
      suppress(state);
    }
  };
  const attach = host => {
    if (hosts.has(host) || !host.shadowRoot) return;
    const id = host.id.slice('app-embed-container-'.length);
    if (!/^\d+$/.test(id)) return;
    const state = { host, id, root: host.shadowRoot, target: false, impressed: false, displayed: false, blocked: false, closedButtons: new WeakSet() };
    hosts.set(host, state);
    const dismissedByUser = event => {
      if (!state.target || state.blocked || !event.composedPath().some(isClose)) return;
      if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
      memory.rememberWelcome(id);
      state.blocked = true;
      queueMicrotask(() => suppress(state));
    };
    state.root.addEventListener('click', dismissedByUser, true);
    state.root.addEventListener('keydown', dismissedByUser, true);
    state.root.addEventListener('keydown', event => {
      if (event.key === 'Escape' && state.target && !state.blocked) {
        const close = state.root.querySelector('[aria-label="Close modal"]');
        if (close) close.click();
      }
    });
    state.observer = new MutationObserver(() => synchronize(state));
    state.observer.observe(state.root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-current-step', 'data-layout'] });
    synchronize(state);
  };
  const scan = () => document.querySelectorAll(selector).forEach(attach);
  const observer = new MutationObserver(mutations => {
    if (mutations.some(mutation => mutation.addedNodes.length)) scan();
    hosts.forEach((state, host) => {
      if (!host.isConnected) { state.observer.disconnect(); hosts.delete(host); }
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  customElements.whenDefined('shopify-forms-embed').then(scan);
  scan();
  window.addEventListener('storage', event => {
    if (event.key !== 'juronoid_welcome_seen_v1') return;
    hosts.forEach(state => { if (state.target && memory.welcomeSeen(state.id)) suppress(state); });
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) hosts.forEach(state => { if (state.target && memory.welcomeSeen(state.id)) suppress(state); });
  });
  const popup = document.getElementById('juronoid-review-popup');
  const reviewData = document.getElementById('juronoid-review-data');
  if (!popup || !reviewData) return;
  let reviews;
  try { reviews = JSON.parse(reviewData.textContent); } catch { return; }
  if (!reviews.length) return;
  let startTimer = null;
  let rotationTimer = null;
  let index = 0;
  const stop = () => {
    clearTimeout(startTimer);
    clearInterval(rotationTimer);
    startTimer = null;
    rotationTimer = null;
    popup.classList.remove('visible');
    popup.hidden = true;
  };
  const update = () => {
    if (memory.reviewsDismissed()) { stop(); return; }
    popup.querySelector('.review-text').textContent = '"' + reviews[index].text + '"';
    popup.querySelector('.author').textContent = reviews[index].author + ', Google-Rezension (Auszug)';
    index = (index + 1) % reviews.length;
  };
  const dismiss = () => { memory.dismissReviews(); stop(); };
  popup.querySelector('.close-btn').addEventListener('click', dismiss);
  popup.addEventListener('keydown', event => { if (event.key === 'Escape') dismiss(); });
  window.addEventListener('pageshow', () => { if (memory.reviewsDismissed()) stop(); });
  window.addEventListener('storage', () => { if (memory.reviewsDismissed()) stop(); });
  if (!memory.canRememberReviews || memory.reviewsDismissed()) { stop(); return; }
  startTimer = setTimeout(() => {
    if (memory.reviewsDismissed()) { stop(); return; }
    update();
    popup.hidden = false;
    popup.classList.add('visible');
    rotationTimer = setInterval(update, 10000);
  }, 4000);
})();
